import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// items: [{ name, to }]  (last item is current, no link)
export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1.5">
            {it.to && !last ? (
              <Link to={it.to} className="transition-colors hover:text-emerald-700">{it.name}</Link>
            ) : (
              <span className="font-medium text-slate-700">{it.name}</span>
            )}
            {!last && <ChevronRight className="h-3.5 w-3.5 text-slate-300" />}
          </span>
        );
      })}
    </nav>
  );
}
